const VALID_OPERATORS = ["gt", "gte", "lt", "lte", "eq"]

function normalizeAmount(value) {
  if (value === null || value === undefined || value === "") return null
  const amount = Number(value)
  return Number.isFinite(amount) && amount >= 0 ? Math.round(amount * 100) / 100 : null
}

function matchesRule(amount, rule) {
  const currentAmount = normalizeAmount(amount)
  const ruleAmount = normalizeAmount(rule && rule.amount)
  if (currentAmount === null || ruleAmount === null || !VALID_OPERATORS.includes(rule.operator)) return false

  const currentCents = Math.round(currentAmount * 100)
  const ruleCents = Math.round(ruleAmount * 100)

  if (rule.operator === "gt") return currentCents > ruleCents
  if (rule.operator === "gte") return currentCents >= ruleCents
  if (rule.operator === "lt") return currentCents < ruleCents
  if (rule.operator === "lte") return currentCents <= ruleCents
  return currentCents === ruleCents
}

function resolveCategory(invoiceIssuer, amount) {
  if (!invoiceIssuer) return null
  const rules = Array.isArray(invoiceIssuer.categoryRules) ? invoiceIssuer.categoryRules : []
  const matchingRule = rules.find((rule) => rule.category && matchesRule(amount, rule))
  return matchingRule ? matchingRule.category : invoiceIssuer.defaultCategory || null
}

export default {
  matchesRule,
  resolveCategory,
}
